import React from 'react';
import { ElevesDashboardProf } from 'types/classe/maClasse';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { MobileTabLineBox } from 'components/atoms/Texts/MobileTabLineBox';

export interface TableMyResultContentProps {
  eleves: ElevesDashboardProf[];
}

export const MobileTabLineChallenge = ({
  eleves
}: TableMyResultContentProps) => {
  return (
    <>
      {eleves.map(
        eleve =>
          eleve.note && (
            <FeatureContainer key={eleve.id} padding="mobileTab">
              <MobileTabLineBox
                texts={[
                  { text: eleve?.lastname, style: 'bold' },
                  { text: eleve?.firstname, style: 'bold' },
                  {
                    text: 'CA (hors port) : ' + eleve.note.cavente + ' / 20',
                    style: 'bottomRegular'
                  },
                  {
                    text: 'Vente(s) totales : ' + eleve.note.nbvente + ' / 20'
                  },
                  { text: 'Vente(s) pro : ' + eleve.note.pro + ' / 20' },
                  {
                    text:
                      'Vente(s) rebond : ' + eleve.note.venterebond + ' / 20'
                  },
                  { text: 'Quiz : ' + eleve.note.quiz + ' / 20' }
                ]}
              />
              <MobileTabLineBox
                title="Note Challenge"
                texts={[
                  { text: eleve.note.moyennegenerale + ' / 20', style: 'bold' }
                ]}
              />
            </FeatureContainer>
          )
      )}
    </>
  );
};
